import React, {Component} from 'react'
import {withStyles} from '@material-ui/core/styles/index'
import {withRouter} from 'react-router-dom'
import {
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
  CircularProgress,
} from '@material-ui/core'
import classNames from 'classnames'
import {FuseAnimate} from '@fuse'
import {requireAuth} from '../../../auth'

import {newProject} from '../../../functions/project'

const styles = theme => ({
  root: {
    background:
      "url('/assets/images/backgrounds/dark-material-bg.jpg') no-repeat",
    backgroundSize: 'cover',
  },
  card: {
    width: '100%',
    maxWidth: 384,
  },
})

class NewProjectPage extends Component {
  state = {
    projectName: '',
    submitting: false,
  }

  onSubmitButtonEnable = () => {
    return !this.state.projectName
  }

  onTextChange = e => {
    this.setState({projectName: e.target.value})
  }

  onCancel = () => {
    this.props.history.push('/projects')
  }

  onNewProject = async () => {
    this.setState({submitting: true})
    try {
      const {data} = await newProject(this.state.projectName)
      //   this.props.history.push(`/project/${projectId}/settings`)
      window.location.replace(`/project/${data.projectId}/settings`)
    } catch (e) {
      console.error(e)
      this.setState({submitting: false})
    }
  }

  render() {
    const {classes} = this.props
    return (
      <div
        className={classNames(
          classes.root,
          'flex flex-col flex-auto flex-no-shrink items-center justify-center p-32',
        )}
      >
        <div className="flex flex-col items-center justify-center w-full">
          <FuseAnimate animation="transition.expandIn">
            <Card className={classes.card}>
              <CardContent className="flex flex-col items-center justify-center p-32">
                <Typography variant="title" className="mt-16 mb-16">
                  New project
                </Typography>
                <div className="w-full">
                  <TextField
                    label="Project name"
                    className="w-full mb-16 mx-8"
                    value={this.state.projectName}
                    onChange={this.onTextChange}
                  />
                  <div className="flex w-full">
                    <Button
                      variant="raised"
                      color="primary"
                      className="flex flex-1 mx-8"
                      aria-label="Cancel"
                      onClick={this.onCancel}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="raised"
                      disabled={
                        this.onSubmitButtonEnable() || this.state.submitting
                      }
                      color="secondary"
                      className="flex flex-1 mx-8"
                      aria-label="Submit"
                      onClick={this.onNewProject}
                    >
                      Submit{' '}
                      {this.state.submitting && (
                        <CircularProgress size={20} className="ml-8" />
                      )}
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          </FuseAnimate>
        </div>
      </div>
    )
  }
}

export default withStyles(styles, {withTheme: true})(
  withRouter(requireAuth(NewProjectPage)),
)



// WEBPACK FOOTER //
// ./src/main/content/projects/NewProjectPage.js